import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ConversationListItem } from './types';

export function useConversations(clientId?: string, familyId?: string) {
  const { flagEnabledSiestaChats } = useFlags();
  return useQuery<ConversationListItem[]>({
    queryKey: ['conversations', { clientId, familyId }],
    // Backend returns 404 on this route when Siesta chats are off, so don't request it then.
    // Strict === true keeps the query disabled while LaunchDarkly is still loading and the flag
    // is undefined, which React Query would otherwise treat as enabled and fire a 404.
    enabled: flagEnabledSiestaChats === true,
    // Poll while the list is open so a turn moving to processing, then unread, shows without a manual refresh.
    refetchInterval: 4000,
  });
}
